<template>
    <v-app>
        <v-card flat class="mx-auto">
            <v-container v-if="isLoading">
                <v-progress-linear
                    color="blue darken-4"
                    indeterminate
                    height="6"
                >
                </v-progress-linear>
                <v-col>
                    <v-skeleton-loader
                        type="list-item-three-line, card-heading, image"
                    ></v-skeleton-loader>
                </v-col>
            </v-container>

            <v-container class="pl-6" v-if="isLoading == false">
                <v-layout row wrap>
                    <v-flex xl12 md12 xs12>
                        <div
                            class="mb-n16 pb-0"
                            v-if="
                                this.$vuetify.breakpoint.name == 'xs' ||
                                    this.$vuetify.breakpoint.name == 'sm'
                            "
                        ></div>

                        <v-card>
                            <div
                                class="grey lighten-4 text-left 
                                                pt-n3"
                            >
                                <h1 class="pa-3" id="news">
                                    {{
                                        $store.state.categoryTypeData
                                            .categoryName
                                    }}
                                </h1>
                            </div>

                            <v-divider></v-divider>

                            <h2
                                class="pa-2 text-left"
                                v-html="this.newsDetail.title"
                            ></h2>
                            <v-chip label class="pa-3 ma-2">{{
                                this.newsDetail.created_at
                            }}</v-chip>
                            <v-spacer></v-spacer>

                            <v-img
                                v-if="newsDetail.featuredImage !== null"
                                class="ma-3"
                                :aspect-ratio="16 / 9"
                                min-height="160px"
                                max-height="512px"
                                :src="
                                    '/uploads/' + this.newsDetail.featuredImage
                                "
                                :alt="newsDetail.altText"
                            ></v-img>
                            <div class="pa-6" v-if="this.categoryType == 7">
                                <v-layout justify-center align-center>
                                    <v-img
                                        justify-center
                                        align-center
                                        lazy-src="images/fundusze-europejskie-wiedza-edukacja-rozwoj.jpg"
                                        max-height="87"
                                        max-width="674"
                                        src="/images/fundusze-europejskie-wiedza-edukacja-rozwoj.jpg"
                                        alt="logo fundusze europejskie wiedza edukacja rozwój"
                                    ></v-img>
                                </v-layout>
                                <div
                                    id="post"
                                    v-html="this.newsDetail.fullPost"
                                    class="pb-6 pa-3"
                                ></div>

                                <v-layout justify-center align-center>
                                    <v-img
                                        lazy-src="images/power-stopka-pwsz.jpg"
                                        max-height="87"
                                        max-width="674"
                                        src="/images/power-stopka-pwsz.jpg.jpg"
                                        alt="logo NCiBR, PWSZ"
                                    ></v-img>
                                </v-layout>
                            </div>
                            <div class="pa-6" v-if="this.categoryType != 7">
                                <div
                                    id="post"
                                    v-html="this.newsDetail.fullPost"
                                    class="pb-6 pa-3"
                                ></div>
                            </div>
                            <v-container>
                                <v-spacer></v-spacer>
                                <div v-if="this.isAttachment == true">
                                    <v-divider></v-divider>
                                    <h3>
                                        Dokumenty do pobrania
                                    </h3>
                                </div>

                                <v-list-item
                                    v-for="attachItem in newsAttach"
                                    :key="attachItem.id"
                                >
                                    <v-list-item-avatar>
                                        <v-icon
                                            class="blue darken-5 "
                                            dark
                                            small
                                        >
                                            mdi-attachment</v-icon
                                        >
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="text-wrap"
                                            v-text="
                                                attachItem.description +
                                                    ' (' +
                                                    attachItem.size +
                                                    ')'
                                            "
                                        >
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-btn
                                        class="blue darken-5"
                                        dark
                                        @click="
                                            downloadFile(
                                                attachItem.id,
                                                attachItem.filename,
                                                attachItem.extension
                                            )
                                        "
                                    >
                                        <v-icon>
                                            mdi-download-outline
                                        </v-icon>
                                    </v-btn>
                                </v-list-item>
                            </v-container>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-divider></v-divider>

                        <v-row row wrap>
                            <v-flex
                                xs6
                                v-for="item in this.news"
                                :key="item.id"
                            >
                                <v-card class="ma-3">
                                    <small class="pa-1">{{
                                        item.created_at
                                    }}</small>
                                    <v-img
                                        v-if="item.featuredImage !== null"
                                        :aspect-ratio="16 / 9"
                                        min-height="160px"
                                        max-height="230px"
                                        :src="'/uploads/' + item.featuredImage"
                                        :alt="item.altText"
                                    ></v-img>
                                    <v-card-subtitle
                                        style="height: 90px;"
                                        class="text-left"
                                        v-html="item.title"
                                    ></v-card-subtitle>

                                    <v-spacer></v-spacer>

                                    <v-card-actions class=" justify-center">
                                        <v-btn
                                            class=" red--text text--darken-5 pa-2 ma-2"
                                            @click="loadNews(item.id)"
                                            >Zobacz więcej</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-row>
                        <v-divider></v-divider>
                        <div class="text-center">
                            <v-pagination
                                class="pa-3"
                                v-model="currentPage"
                                :length="this.page.last_page"
                                circle
                                color="blue darken-5"
                                :total-visible="6"
                                @input="handlePageChange"
                            ></v-pagination>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </v-app>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    components: {},

    data() {
        return {
            id: "",
            hover: true,
            categoryDetailPage: false,
            isfeaturedImage: false,
            isAttachment: false,
            categorySlug: "",
            categoryType: null,
            news: [],
            newsDetail: [],
            newsAttach: [],
            breadcrumbsItems: [],
            page: "",
            currentPage: 1,
            isLoading: false,
            url: "",
            categoryType: "",
            pageTemplate: "default"
        };
    },

    methods: {
        forceFileDownload(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", this.filename); //or any other extension
            document.body.appendChild(link);
            link.click();
        },

        async downloadFile(file_id, description, ext) {
            this.filename = description + "." + ext;

            axios({
                method: "get",
                url: `/file/download/${file_id}`,
                responseType: "arraybuffer"
            })
                .then(response => {
                    this.forceFileDownload(response);
                })
                .catch(() => console.log("error occured"));
        },

        async handlePageChange(value) {
            this.currentPage = value;
            const res = await this.callApi(
                "get",
                `/get_news_list_category?page=${this.currentPage}`
            );
            if (res.status == 200) {
                this.news = res.data.newsData;
                this.page = res.data.pageData;
            }
        },

        async loadNews(id) {
            const [newsDetail] = await Promise.all([
                this.callApi("get", `/get_news_details/` + id)
            ]);
            if (newsDetail.status == 200) {
                this.newsDetail = newsDetail.data.newsData[0];
                document.title = this.newsDetail.title + " - puas.pl";

                this.newsAttach = newsDetail.data.newsAttach;

                if (newsDetail.data.newsAttach) {
                    if (newsDetail.data.newsAttach.length > 0) {
                        this.isAttachment = true;
                    } else {
                        this.isAttachment = false;
                    }
                }
                this.$vuetify.goTo("#news");
            }
        }
    },

    mounted() {
        this.categoryType = this.$store.state.categoryTypeData.categoryType;
        //console.log("mounted category_id", this.$store.state.categoryTypeData.categoryType);
    },

    async created() {
        this.categoryType = this.$store.state.categoryTypeData.categoryType;

        const [news] = await Promise.all([
            this.callApi("get", `/get_news_category/` + this.categoryType)
        ]);

        if (news.status == 200) {
            this.newsDetail = news.data.newsData[0];
            document.title = this.newsDetail.title + " - puas.pl";
            this.news = news.data.newsData;
            this.page = news.data.pageData;
        }
    }
};
</script>
<style scoped>
#post >>> iframe {
    border: 15px solid #f5f5f5;
    width: 100%;
    min-height: 640px;
    min-height: 720px;
}
#post {
    overflow-wrap: break-word;
}
#post >>> p {
    line-height: 1.7em;
    padding: 5px;
}
#post >>> h1 {
    text-transform: uppercase;
    color: black;
    border-left: 20px solid #c20444;
    border-bottom: 1px solid #c20444;
    font-weight: normal;
    padding: 5px 0px 5px 30px;
    margin: 0px 0px 5px 0px;
}

#post >>> hr {
    margin: 5px 0px 30px 0px;
    color: #e9e9e9;
    border: 1px solid #e9e9e9;
}

#post >>> h2 {
    border-left: 20px solid #0e3d85;
    border-bottom: 1px solid #0e3d85;
    font-weight: normal;
    padding: 5px 0px 5px 30px;
    margin: 0px 0px 5px 0px;
}

#post >>> h3 {
    border-left: 20px solid #2e62ad;
    border-bottom: 1px solid #2e62ad;
    /*color: white;
    background: #05355a;
    font-weight: normal;
    */
    font-weight: 600;
    padding: 10px 0px 10px 10px;
    margin: 0px 0px 10px 0px;
}

.attach {
    background: #0e3d85;
}

#post >>> table tr td ol ul {
    margin-top: 0px;
}

#post >>> table li {
    margin-left: 0px;
}

#post >>> ul ol {
    margin-top: -20px;
}
#post >>> li {
    margin-left: 2.5em;
    padding: 2px;
}

#post >>> li:first-child {
    border: 0px solid red;
    margin-top: 0px;
}
#post >>> tr td {
    padding: 10px;
}

#breadcrumbs {
    margin: 0px 15px 0px 0px;
    padding: 10px;
    background: #f5f5f5;
}

#headerMenu {
    font-weight: bold;
    overflow-wrap: break-word;
    min-height: 50px;
    text-transform: uppercase;
}
</style>
